import Model from '@/models/Model'

export default class PchDetailPurchaseOrder extends Model {
    /**
     *
     */
    get remnant() {
        return this.quantity - this.received
    }

    /**
     *
     */
    get wh_product_internal_code() {
        return this.wh_product.internal_code
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get wh_product_name() {
        return this.wh_product.name
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get wh_product_service_name() {
        return this.wh_product_service.name
    }

    /**
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'pch_detail_purchase_order'
    }
}
